import { InjectionToken } from '@angular/core';
import { ApiConfiguration } from '../interfaces/api-config';

export const API_CONFIGURATION: InjectionToken<ApiConfiguration> =
  new InjectionToken<ApiConfiguration>('API_CONFIGURATION');
